// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__o6lvT","black":"siteholder_black__5Pm7F","white":"siteholder_white__zdL9s","img":"siteholder_img__fHeIp","zoomin":"siteholder_zoomin__En2LA"};